module.exports = __webpack_public_path__ + "static/and-then-there-were-none-5c7c3f8bb9d2af78c352b6276d2e672b.jpg";